import { render, staticRenderFns } from "./OfertaPopup.vue?vue&type=template&id=40e37c2a&scoped=true"
import script from "./OfertaPopup.vue?vue&type=script&lang=ts"
export * from "./OfertaPopup.vue?vue&type=script&lang=ts"
import style0 from "./OfertaPopup.vue?vue&type=style&index=0&id=40e37c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e37c2a",
  null
  
)

export default component.exports